const translationsElement = document.querySelector('[data-translations]');
const translations = JSON.parse(translationsElement.dataset.translations);

/**
 * Translate a key with optional parameter replacement
 * @param {string} key - The translation key in dot notation (e.g., 'common.weekdays.monday')
 * @param {Object} params - Optional parameters for placeholder replacement
 * @returns {string} The translated string with placeholders replaced
 */
export const translate = (key, params = null) => {
  const translation = translations[key];

  if (!translation) {
    return key;
  }

  if (!params) {
    return translation;
  }

  return translation.replace(/{([^{}]+)}/g, (match, paramName) => {
    return params[paramName] ?? match;
  });
};
